<template>
  <v-container fluid class="pa-0">
    <!-- Si no hay un ciclo cargado, mostrar alerta -->
    <v-row v-if="!cicloActivo || !cicloActivo.id">
      <v-col cols="12" class="text-center py-10">
        <v-icon size="64" color="grey lighten-1">mdi-alert-circle-outline</v-icon>
        <h3 class="text-h6 grey--text text--darken-2 mt-4">No hay un Ciclo Activo seleccionado</h3>
        <p class="grey--text">Para analizar el rendimiento, primero debes tener configurado un ciclo de presupuestos.
        </p>
        <v-btn color="primary" outlined @click="cargarRendimientoGlobal(cicloId)" :loading="cargandoComponente">
          <v-icon left>mdi-refresh</v-icon> Intentar Cargar Ciclo Reciente
        </v-btn>
      </v-col>
    </v-row>

    <!-- Content (if cycle loaded) -->
    <div v-else>
      <v-card outlined class="rounded-lg pa-4 mb-4 bg-light-blue border-primary">
        <v-row align="center">
          <v-col cols="12" md="4" class="py-1">
            <span class="text-caption grey--text text--darken-1 text-uppercase font-weight-bold">Conexiones Activas ({{
              instancia }})</span>
            <div class="text-subtitle-1 font-weight-bold primary--text">
              <v-icon color="#1877F2" small class="mr-1">mdi-facebook</v-icon> Meta Ads &
              <v-icon color="#EA4335" small class="ml-1 mr-1">mdi-google</v-icon> Google Ads
            </div>
          </v-col>
          <v-col cols="12" md="4" class="py-1">
            <span class="text-caption grey--text text--darken-1 text-uppercase font-weight-bold">Periodo del
              Ciclo</span>
            <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">
              {{ formatFecha(cicloActivo.fecha_inicio) }} - {{ formatFecha(cicloActivo.fecha_fin) }}
            </div>
          </v-col>
          <v-col cols="12" md="4" class="text-md-right py-1">
            <v-btn color="secondary" :loading="sincronizando" @click="sincronizarApis(true)">
              <v-icon left>mdi-cloud-sync</v-icon> Actualizar Gastos Reales
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-row>
        <!-- Gráficos de APIs -->
        <v-col cols="12">
          <v-card outlined class="rounded-lg fill-height" :loading="sincronizando">
            <v-card-title class="pb-0">
              <v-icon color="primary" class="mr-2">mdi-chart-line</v-icon>
              Gasto Acumulado por Periodo (APIs)
            </v-card-title>
            <v-card-text>
              <p class="text-body-2 grey--text text--darken-2">
                Consulta los importes en tiempo real extraídos de las plataformas de anuncios para la instancia
                seleccionada, desde el arranque del ciclo hasta hoy.
              </p>

              <v-row class="mt-4">
                <v-col cols="12" md="6">
                  <v-card elevation="1" class="pa-4 text-center rounded-lg" outlined
                    style="border-top: 4px solid #1877F2;">
                    <div class="text-h6 font-weight-bold mb-2">Meta Ads</div>
                    <div class="text-h3 font-weight-black"
                      :class="metricas.meta_spend > 0 ? 'black--text' : 'grey--text'">
                      {{ metricas.meta_spend | currency }}
                    </div>
                    <div class="text-caption grey--text mt-2">Desglose por Sucursal</div>
                    <v-list dense class="mt-3 text-left bg-light-grey rounded pb-0">
                      <!-- CDMX -->
                      <template v-if="instancia === 'INBI'">
                        <v-list-group v-if="Object.keys(metricas.meta_desglose.CDMX).length > 0" :value="false">
                          <template v-slot:activator>
                            <v-list-item-content><v-list-item-title>CDMX</v-list-item-title></v-list-item-content>
                            <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.CDMX | currency }}</v-list-item-action>
                          </template>
                          <v-list-item v-for="(val, name) in metricas.meta_desglose.CDMX" :key="'cdmx-'+name" class="pl-6">
                            <v-list-item-content><v-list-item-subtitle class="text-caption">{{ name }}</v-list-item-subtitle></v-list-item-content>
                            <v-list-item-action class="text-caption">{{ val | currency }}</v-list-item-action>
                          </v-list-item>
                        </v-list-group>
                        <v-list-item v-else>
                          <v-list-item-content><v-list-item-title>CDMX</v-list-item-title></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.CDMX | currency }}</v-list-item-action>
                        </v-list-item>
                      </template>
                      
                      <!-- GDL -->
                      <template v-if="instancia === 'INBI'">
                        <v-list-group v-if="Object.keys(metricas.meta_desglose.GDL).length > 0" :value="false">
                          <template v-slot:activator>
                            <v-list-item-content><v-list-item-title>GDL</v-list-item-title></v-list-item-content>
                            <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.GDL | currency }}</v-list-item-action>
                          </template>
                          <v-list-item v-for="(val, name) in metricas.meta_desglose.GDL" :key="'gdl-'+name" class="pl-6">
                            <v-list-item-content><v-list-item-subtitle class="text-caption">{{ name }}</v-list-item-subtitle></v-list-item-content>
                            <v-list-item-action class="text-caption">{{ val | currency }}</v-list-item-action>
                          </v-list-item>
                        </v-list-group>
                        <v-list-item v-else>
                          <v-list-item-content><v-list-item-title>GDL</v-list-item-title></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.GDL | currency }}</v-list-item-action>
                        </v-list-item>
                      </template>
                      
                      <!-- MTY -->
                      <v-list-group v-if="Object.keys(metricas.meta_desglose.MTY).length > 0" :value="false">
                        <template v-slot:activator>
                          <v-list-item-content><v-list-item-title>MTY</v-list-item-title></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.MTY | currency }}</v-list-item-action>
                        </template>
                        <v-list-item v-for="(val, name) in metricas.meta_desglose.MTY" :key="'mty-'+name" class="pl-6">
                           <v-list-item-content><v-list-item-subtitle class="text-caption">{{ name }}</v-list-item-subtitle></v-list-item-content>
                           <v-list-item-action class="text-caption">{{ val | currency }}</v-list-item-action>
                        </v-list-item>
                      </v-list-group>
                      <v-list-item v-else>
                        <v-list-item-content><v-list-item-title>MTY</v-list-item-title></v-list-item-content>
                        <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.MTY | currency }}</v-list-item-action>
                      </v-list-item>
                      
                      <!-- Online / Nacional -->
                      <v-list-group v-if="Object.keys(metricas.meta_desglose.Online).length > 0" :value="false">
                        <template v-slot:activator>
                          <v-list-item-content><v-list-item-title>Online / Nacional</v-list-item-title></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.Online | currency }}</v-list-item-action>
                        </template>
                        <v-list-item v-for="(val, name) in metricas.meta_desglose.Online" :key="'online-'+name" class="pl-6">
                           <v-list-item-content><v-list-item-subtitle class="text-caption">{{ name }}</v-list-item-subtitle></v-list-item-content>
                           <v-list-item-action class="text-caption">{{ val | currency }}</v-list-item-action>
                        </v-list-item>
                      </v-list-group>
                      <v-list-item v-else>
                        <v-list-item-content><v-list-item-title>Online / Nacional</v-list-item-title></v-list-item-content>
                        <v-list-item-action class="font-weight-bold">{{ metricas.meta_ciudades.Online | currency }}</v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <v-list dense class="text-left bg-light-grey rounded mt-1 pt-0">
                      <v-list-item>
                        <v-list-item-content><v-list-item-subtitle class="text-caption">Impresiones /
                            Clics</v-list-item-subtitle></v-list-item-content>
                        <v-list-item-action class="text-caption">{{ metricas.meta_impressions | numeral }} / {{
                          metricas.meta_clicks | numeral }}</v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>

                <v-col cols="12" md="6">
                  <v-card elevation="1" class="pa-4 text-center rounded-lg" outlined
                    style="border-top: 4px solid #EA4335;">
                    <div class="text-h6 font-weight-bold mb-2">Google Ads</div>
                    <div v-if="metricas.google_error">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <div class="text-subtitle-2 red--text text--lighten-1 mb-1 font-weight-bold" v-bind="attrs"
                            v-on="on">
                            <v-icon small color="red">mdi-alert</v-icon> Fallback Manual Activo
                          </div>
                        </template>
                        <span>{{ metricas.google_error_msg }}</span>
                      </v-tooltip>
                      <div class="d-flex align-center justify-center mx-auto" style="max-width: 200px;">
                        <v-text-field v-model.number="metricas.google_spend" type="number" prefix="$" outlined dense
                          hide-details class="mt-2 mb-2 font-weight-bold" :disabled="!puedeEditar">
                          <template v-slot:append-outer>
                            <v-btn icon color="primary" small class="mt-n1" @click="guardarGastoManualGoogle" :disabled="!puedeEditar">
                              <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                          </template>
                        </v-text-field>
                      </div>
                    </div>
                    <div v-else>
                      <div class="text-h3 font-weight-black"
                        :class="metricas.google_spend > 0 ? 'black--text' : 'grey--text'">
                        {{ metricas.google_spend | currency }}
                      </div>
                      <div class="text-caption grey--text mt-2">Desglose por Sucursal</div>

                      <v-list dense class="mt-3 text-left bg-light-grey rounded pb-0">
                        <v-list-item v-if="instancia === 'INBI'">
                          <v-list-item-content><v-list-item-subtitle>CDMX</v-list-item-subtitle></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.google_ciudades.CDMX | currency
                            }}</v-list-item-action>
                        </v-list-item>
                        <v-list-item v-if="instancia === 'INBI'">
                          <v-list-item-content><v-list-item-subtitle>GDL</v-list-item-subtitle></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.google_ciudades.GDL | currency
                            }}</v-list-item-action>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content><v-list-item-subtitle>MTY</v-list-item-subtitle></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.google_ciudades.MTY | currency
                            }}</v-list-item-action>
                        </v-list-item>
                        <v-list-item>
                          <v-list-item-content><v-list-item-subtitle>Online /
                              Nacional</v-list-item-subtitle></v-list-item-content>
                          <v-list-item-action class="font-weight-bold">{{ metricas.google_ciudades.Online | currency
                            }}</v-list-item-action>
                        </v-list-item>
                      </v-list>
                      <v-list dense class="text-left bg-light-grey rounded mt-1 pt-0">
                        <v-list-item>
                          <v-list-item-content><v-list-item-subtitle class="text-caption">Impresiones /
                              Clics</v-list-item-subtitle></v-list-item-content>
                          <v-list-item-action class="text-caption">{{ metricas.google_impressions | numeral }} / {{
                            metricas.google_clicks |
                            numeral }}</v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </div>

                    <v-list dense class="mt-3 text-left bg-light-grey rounded" style="border-top: 2px solid #e0e0e0;">
                      <v-list-item>
                        <v-list-item-content><v-list-item-subtitle>Total Combinado
                            (APIs)</v-list-item-subtitle></v-list-item-content>
                        <v-list-item-action class="font-weight-black success--text">{{ totalGastoApis | currency
                          }}</v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import moment from 'moment';

export default {
  name: 'TabRendimiento',
  props: {
    instancia: { type: String, required: true },
    isDirector: { type: Boolean, default: false },
    cicloId: { type: [Number, String], default: null },
    isActivo: { type: Boolean, default: false }
  },

  data() {
    return {
      cargandoComponente: false,
      sincronizando: false,
      cicloActivo: null,

      metricas: {
        meta_spend: 0,
        meta_impressions: 0,
        meta_clicks: 0,
        meta_ciudades: {
          CDMX: 0,
          GDL: 0,
          MTY: 0,
          Online: 0
        },
        meta_desglose: {
          CDMX: {},
          GDL: {},
          MTY: {},
          Online: {}
        },

        google_spend: 0,
        google_impressions: 0,
        google_clicks: 0,
        google_ciudades: {
          CDMX: 0,
          GDL: 0,
          MTY: 0,
          Online: 0
        },
        google_error: false,
        google_error_msg: ""
      }
    };
  },

  computed: {
    puedeEditar() {
      return this.isDirector && this.isActivo;
    },
    totalGastoApis() {
      return this.metricas.meta_spend + this.metricas.google_spend;
    }
  },

  watch: {
    cicloId: {
      immediate: true,
      handler(newVal) {
        this.cargarRendimientoGlobal(newVal);
      }
    }
  },

  methods: {
    async cargarRendimientoGlobal(id) {
      if (!id) {
        this.cicloActivo = null;
        return;
      }
      this.cargandoComponente = true;
      try {
        const resCiclo = await this.$http.get(`api/presupuestos/ciclo/${id}`);
        if (resCiclo.data) {
          this.cicloActivo = resCiclo.data;
          this.sincronizarApis();
        } else {
          this.cicloActivo = null;
        }
      } catch (error) {
        console.error("Error cargando ciclo", error);
      } finally {
        this.cargandoComponente = false;
      }
    },

    async sincronizarApis(forceRefresh = false) {
      if (!this.cicloActivo) return;

      this.sincronizando = true;

      // Reiniciar métricas
      this.metricas = {
        meta_spend: 0,
        meta_impressions: 0,
        meta_clicks: 0,
        meta_ciudades: { CDMX: 0, GDL: 0, MTY: 0, Online: 0 },
        meta_desglose: { CDMX: {}, GDL: {}, MTY: {}, Online: {} },
        google_spend: 0,
        google_impressions: 0,
        google_clicks: 0,
        google_ciudades: { CDMX: 0, GDL: 0, MTY: 0, Online: 0 },
        google_error: false,
        google_error_msg: ""
      };

      // Siempre extraemos gasto hasta la fecha techo oficial del ciclo, nunca días extra del futuro.
      const inicio = moment(this.cicloActivo.fecha_inicio).format('YYYY-MM-DD');
      let fin = moment().format('YYYY-MM-DD');
      const finCiclo = moment(this.cicloActivo.fecha_fin).format('YYYY-MM-DD');
      if (fin > finCiclo || !this.isActivo) fin = finCiclo;

      const procesarDatosMeta = (data) => {
          this.metricas.meta_spend = data.reduce((acc, curr) => acc + (parseFloat(curr.spend) || 0), 0);
          this.metricas.meta_impressions = data.reduce((acc, curr) => acc + (parseInt(curr.impressions) || 0), 0);
          this.metricas.meta_clicks = data.reduce((acc, curr) => acc + (parseInt(curr.clicks) || 0), 0);

          data.forEach(camp => {
             const spend = parseFloat(camp.spend) || 0;
             const name = camp.campaign_name ? camp.campaign_name.toLowerCase() : '';
             
             // Helper interno para emular la detección de sucursal oficial del servidor
             const detectarSucursal = (campName) => {
               if (!campName) return 'General';
               const upper = campName.toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
               
               if (upper.includes("ONLINE")) return "Online";
               
               // FAST
               if (upper.includes("NORIA")) return "La Noria";
               if (upper.includes("ROMULO") || upper.includes("GARZA")) return "Rómulo Garza";
               if (upper.includes("UNIVERSIDAD") || upper.includes("UNI ")) return "Universidad";
               if (upper.includes("MITRAS")) return "Mitras";
               if (upper.includes("ELOY") || upper.includes("CAVAZOS")) return "Eloy Cavazos";
               if (upper.includes("LINDA") || upper.includes("VISTA") || upper.includes("LINDAVISTA")) return "Linda Vista";
               if (upper.includes("GUADALUPE")) return "Guadalupe";
               
               // INBI
               if (upper.includes("LINCOLN")) return "Lincoln";
               if (upper.includes("SANTA CATARINA") || upper.includes("MTY SANTA")) return "Santa Catarina";
               if (upper.includes("ESCOBEDO")) return "Escobedo";
               if (upper.includes("FRESNOS")) return "Fresnos";
               if (upper.includes("MIGUEL ALEMAN") || upper.includes("MIGUEL ALEMÁN")) return "Miguel Alemán";
               if (upper.includes("PABLO LIVAS")) return "Pablo Livas";
               if (upper.includes("CASA BLANCA")) return "Casa Blanca";
               if (upper.includes("SAN MIGUEL")) return "San Miguel";
               if (upper.includes("APODACA")) return "Apodaca";
               
               if (upper.includes("CUITLAHUAC")) return "Cuitláhuac";
               if (upper.includes("MISTERIOS")) return "Misterios";
               if (upper.includes("MONTEVIDEO")) return "Montevideo";
               if (upper.includes("ANAHUAC") || upper.includes("ANÁHUAC")) return "Anáhuac";
               if (upper.includes("ARAGON") || upper.includes("ARAGÓN")) return "Aragón";
               
               if (upper.includes("REVOLUCION") || (upper.includes("GDL") && !upper.includes("TRANSITO"))) return "Guadalajara Revolución";
               if (upper.includes("TRANSITO")) return "Guadalajara Tránsito";
               
               return 'Campaña General';
             };

             let sucursalMatch = detectarSucursal(camp.campaign_name);
             
             let ciudadMatch = "Online";
             let testName = camp.campaign_name.toLowerCase();
             
             if (sucursalMatch === 'Online') {
                 ciudadMatch = "Online";
             } else if (
                 ['Lincoln', 'Santa Catarina', 'Escobedo', 'Fresnos', 'Miguel Alemán', 'Pablo Livas', 'Casa Blanca', 'San Miguel', 'Apodaca', 'Mitras', 'Universidad', 'La Noria', 'Rómulo Garza', 'Eloy Cavazos', 'Linda Vista', 'Guadalupe'].includes(sucursalMatch) || 
                 testName.includes('mty') || testName.includes('monterrey') || testName.includes('san nicolas') || testName.includes('apodaca')
             ) {
                 ciudadMatch = "MTY";
             } else if (
                 ['Guadalajara Revolución', 'Guadalajara Tránsito'].includes(sucursalMatch) || 
                 testName.includes('gdl') || testName.includes('guadalajara') || testName.includes('zapopan')
             ) {
                 ciudadMatch = "GDL";
             } else if (
                 ['Cuitláhuac', 'Misterios', 'Montevideo', 'Anáhuac', 'Aragón'].includes(sucursalMatch) || 
                 testName.includes('cdmx') || testName.includes('mexico') || testName.includes('montevideo')
             ) {
                 ciudadMatch = "CDMX";
             }

             if (ciudadMatch === "MTY") {
               this.metricas.meta_ciudades.MTY += spend;
               this.metricas.meta_desglose.MTY[sucursalMatch] = (this.metricas.meta_desglose.MTY[sucursalMatch] || 0) + spend;
             } else if (ciudadMatch === "GDL") {
               this.metricas.meta_ciudades.GDL += spend;
               this.metricas.meta_desglose.GDL[sucursalMatch] = (this.metricas.meta_desglose.GDL[sucursalMatch] || 0) + spend;
             } else if (ciudadMatch === "CDMX") {
               this.metricas.meta_ciudades.CDMX += spend;
               this.metricas.meta_desglose.CDMX[sucursalMatch] = (this.metricas.meta_desglose.CDMX[sucursalMatch] || 0) + spend;
             } else {
               this.metricas.meta_ciudades.Online += spend;
               this.metricas.meta_desglose.Online[sucursalMatch] = (this.metricas.meta_desglose.Online[sucursalMatch] || 0) + spend;
             }
          });
      };

      const procesarDatosGoogle = (data) => {
          this.metricas.google_spend = data.reduce((acc, curr) => acc + (parseFloat(curr.spend) || 0), 0);
          this.metricas.google_impressions = data.reduce((acc, curr) => acc + (parseInt(curr.impressions) || 0), 0);
          this.metricas.google_clicks = data.reduce((acc, curr) => acc + (parseInt(curr.clicks) || 0), 0);

          data.forEach(camp => {
             const spend = parseFloat(camp.spend) || 0;
             const name = camp.campaign_name ? camp.campaign_name.toLowerCase() : '';
             if (name.includes('mty') || name.includes('monterrey') || name.includes('san nicolas') || name.includes('apodaca')) {
               this.metricas.google_ciudades.MTY += spend;
             } else if (name.includes('gdl') || name.includes('guadalajara') || name.includes('zapopan')) {
               this.metricas.google_ciudades.GDL += spend;
             } else if (name.includes('cdmx') || name.includes('mexico') || name.includes('montevideo')) {
               this.metricas.google_ciudades.CDMX += spend;
             } else {
               this.metricas.google_ciudades.Online += spend;
             }
          });
      };

      const fetchMeta = async () => {
        if (!forceRefresh) {
            try {
                const cacheObj = await this.$http.get(`api/presupuestos/api-cache/${this.cicloActivo.id}/Meta`);
                if (cacheObj.data && cacheObj.data.data) {
                    procesarDatosMeta(cacheObj.data.data);
                    return;
                }
            } catch(e) { /* ignore and fallback to fetch */ }
        }
        
        try {
            const res = await this.$http.post('api/presupuestos/meta/spend', { instancia: this.instancia, date_start: inicio, date_stop: fin });
            if (res.data && res.data.length > 0) {
                procesarDatosMeta(res.data);
                this.$http.post('api/presupuestos/api-cache', { id_presupuesto_ciclo: this.cicloActivo.id, canal: 'Meta', response_json: res.data }).catch(e => console.warn("Cache save err", e));
            }
        } catch(err) {
            console.error("Meta Ads Error:", err);
        }
      };

      const fetchGoogle = async () => {
        if (!forceRefresh) {
            try {
                const cacheObj = await this.$http.get(`api/presupuestos/api-cache/${this.cicloActivo.id}/Google`);
                if (cacheObj.data && cacheObj.data.data) {
                    procesarDatosGoogle(cacheObj.data.data);
                    return;
                }
            } catch(e) { /* ignore and fallback to fetch */ }
        }
        
        try {
            const res = await this.$http.post('api/presupuestos/google/spend', { instancia: this.instancia, date_start: inicio, date_stop: fin });
            if (res.data && res.data.length > 0) {
                procesarDatosGoogle(res.data);
                this.$http.post('api/presupuestos/api-cache', { id_presupuesto_ciclo: this.cicloActivo.id, canal: 'Google', response_json: res.data }).catch(e => console.warn("Cache save err", e));
            }
        } catch(err) {
            console.error("Google Ads Error:", err);
            this.metricas.google_error = true;
            this.metricas.google_error_msg = err.response && err.response.data ? err.response.data.message : err.message;
            try {
              const resManual = await this.$http.get(`api/presupuestos/gasto_manual/${this.cicloActivo.id}`);
              if (resManual.data) {
                const gastosGoogle = resManual.data.filter(g => g.canal === 'Google Ads');
                this.metricas.google_spend = gastosGoogle.reduce((acc, curr) => acc + (parseFloat(curr.monto_gastado) || 0), 0);
              }
            } catch (fallbackErr) { console.error("Error leyendo fallback:", fallbackErr); }
        }
      };

      await Promise.allSettled([fetchMeta(), fetchGoogle()]);

      this.sincronizando = false;
      console.log("Sincronización de APIs finalizada.");
    },

    async guardarGastoManualGoogle() {
      if (!this.puedeEditar || !this.cicloActivo) return;
      try {
        const payload = {
          id_presupuesto_ciclo: this.cicloActivo.id,
          fecha: moment().format('YYYY-MM-DD'), // Fecha de la inserción
          canal: 'Google Ads',
          instancia: this.instancia,
          monto_gastado: this.metricas.google_spend,
          usuario_registro: 1 // TODO: Tomar de Vuex Auth
        };
        await this.$http.post('api/presupuestos/gasto_manual', payload);
        console.log("Gasto manual guardado con éxito.");
      } catch (error) {
        console.error("Error guardando gasto manual", error);
      }
    },

    formatFecha(fechaStr) {
      if (!fechaStr) return '';
      return moment(fechaStr).format('DD MMM, YYYY');
    }

  },

  filters: {
    currency(value) {
      if (typeof value !== "number") return value;
      return "$" + value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    numeral(value) {
      if (typeof value !== "number") return value;
      return value.toLocaleString('en-US');
    }
  }
};
</script>

<style scoped>
.bg-light-blue {
  background-color: #F1F8FF;
}

.bg-light-grey {
  background-color: #fcfcfc;
}

.border-primary {
  border: 1px solid var(--v-primary-base) !important;
}
</style>
